<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        

        <b-card>
          <h4>Packages report A</h4>
          <div class="row mb-2" v-if="packageA.length > 0">
            <div class="col-sm-6">
              <span class="badge badge-success mr-2">Total Search Data Found: {{ packageA.length }}</span>
            </div>
          </div>
          <div class="scrollable-table table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>Sl</th>
                <th>EP Name</th>
                <th>Father's Name</th>
                <th>Package no</th>
                <th>House type</th>
                <th>House no.</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(pkgA, index) in packageA" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ pkgA.name }}</td>
                <td>{{ pkgA.father_husband_name }}</td>
                <td>{{ pkgA.desc }}</td>
                <td>A</td>
                <!-- <td> -->
                  <!-- <div v-for="(pkg, index) in land_infos.pkgs" :key="index" >
                    <span v-if="pkg.id == land_info.package_id">
                      {{ pkg.desc }}
                    </span>
                  </div> -->
                <!-- </td> -->
                <td>{{ pkgA.house_no }}</td>
              </tr>
              </tbody>
            </table>
            <h5 v-if="!flag" class="text-center text-secondary">
              No Data Found
            </h5>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

export default {
  page: {
    title: "House Report Package",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "House Report Package",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Land",
          active: true
        }
      ],
      packageA: [],
      flag: false
    };
  },

  mounted() {
    //this.searchPackage(id);
    this.packagesReport()
  },
  methods: {
    packagesReport() {
      http.get("api/ses/land/house/report/package/A").then(response => {
        if (!response.error) {
          this.flag = true;
          console.log(response.data)
          this.packageA = response.data;
        }
      });
    },
  },
  computed: {
    userPermission () {
      return this.$store.state.user
    }
  },
  created () {
    this.$store.dispatch('getUserPermission')
  },
};
</script>
